<div [formGroup]="controlFormGroup" class="input">
  <label [class.is-invalid-label]="hasErrors()">
    <ng-container *ngIf="hasLabel">
      {{ controlName | controlNameToHuman | snakeCaseToHuman }}
    </ng-container>
    <i
      *ngIf="isPassword"
      (click)="isPasswordVisible = !isPasswordVisible"
      class="fa input__password-icon"
      [class.fa-eye]="!isPasswordVisible"
      [class.fa-eye-slash]="isPasswordVisible"
    ></i>
    <!-- Input !== phone_number -->
    <input
      *ngIf="controlName !== 'phone_number' && controlName !== 'fax'"
      [name]="controlName"
      [type]="controlName | inputType: isPasswordVisible"
      [placeholder]="placeholder || 'Enter ' + (controlName | controlNameToHuman | snakeCaseToHuman)"
      [class.input--has-password]="isPassword"
      [class.is-invalid-input]="hasErrors()"
      [class.margin-bottom-none]="!hasErrors()"
      [formControlName]="controlName"
      [textMask]="{ mask: controlName | inputMask }"
      [autocomplete]="autocomplete ? 'on' : 'off'"
      [attr.data-cy]="dataCy"
    />
    <!-- Phone number component -->
    <rav-phone-number
      *ngIf="controlName === 'phone_number' || controlName === 'fax'"
      [controlName]="controlName"
      [controlFormGroup]="controlFormGroup"
    ></rav-phone-number>
  </label>
</div>

<rav-field-errors
  [controlFormGroup]="controlFormGroup"
  [controlName]="controlName"
  [hasErrors]="hasErrors()"
></rav-field-errors>
